import { Gamepad2 } from "lucide-react"
import type {
	PaletteCommand,
	PaletteContext,
	PaletteStep,
} from "../types"

export interface PaletteGame {
	gameSlug: string
	gameName: string
}

export async function loadGames(ctx: PaletteContext): Promise<PaletteGame[]> {
	const rows = await ctx.queryClient.fetchQuery({
		queryKey: ["command-palette", "games"],
		queryFn: () => ctx.gameAdminClient.catalogueQuality.listGames({}),
		staleTime: 5 * 60 * 1000,
	})
	return rows.map((row) => ({ gameSlug: row.gameSlug, gameName: row.gameName }))
}

export async function gamePickerStep(
	ctx: PaletteContext,
	title: string,
	build: (game: PaletteGame) => Omit<PaletteCommand, "id" | "label" | "group">,
): Promise<PaletteStep> {
	const games = await loadGames(ctx)
	return {
		title,
		placeholder: "Pick a game…",
		commands: games.map((game) => ({
			id: `${title}:${game.gameSlug}`,
			label: game.gameName,
			group: "navigate" as const,
			icon: Gamepad2,
			keywords: [game.gameSlug],
			...build(game),
		})),
	}
}
